import { TemplateName } from "../types";
import { NNR_DISPLAY_ID_TYPES } from "./alternateIdKinds";
import { NewlyNotReportingListTemplate } from "./listTemplate";
export class NewlyNotReportingT2MTemplate extends NewlyNotReportingListTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.NewlyNotReportingT2M;
    }
    getDisplayIdType() {
        return NNR_DISPLAY_ID_TYPES.TIER2_MANAGER;
    }
}
//# sourceMappingURL=t2m.js.map